import * as React from 'react';

const AttachmentSmallIcon = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2938 5L5.08702 10.2932C4.89949 10.4807 4.79413 10.7351 4.79413 11.0003C4.79413 11.2655 4.89949 11.5199 5.08702 11.7074C5.27456 11.8949 5.52891 12.0003 5.79413 12.0003C6.05935 12.0003 6.3137 11.8949 6.50124 11.7074L12.708 5.41421C12.8937 5.2285 13.041 5.00802 13.1415 4.76537C13.242 4.52272 13.2938 4.26264 13.2938 4C13.2938 3.73736 13.242 3.47728 13.1415 3.23463C13.041 2.99198 12.8937 2.7715 12.708 2.58579C12.5223 2.40007 12.3018 2.25275 12.0591 2.15224C11.8165 2.05173 11.5564 2 11.2938 2C11.0311 2 10.771 2.05173 10.5284 2.15224C10.2857 2.25275 10.0653 2.40007 9.87955 2.58579L3.67281 8.87898C3.1102 9.44159 2.79413 10.2047 2.79413 11.0003C2.79413 11.796 3.1102 12.559 3.67281 13.1216C4.23542 13.6842 4.99848 14.0003 5.79413 14.0003C6.58978 14.0003 7.35284 13.6842 7.91545 13.1216L13.0438 8"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AttachmentSmallIcon;
